import {Autocomplete} from '@react-google-maps/api'
import {AppBar , Toolbar , Typography , InputBase , Box} from '@material-ui/core' 
import SearchIcon from '@material-ui/icons/Search';
import useStyles from './styles'
import { useState } from 'react';


function Header({setCoordinates}) {

    const classes = useStyles() ;  //hook for material ui custom styles file
    
    const [autocomplete, setAutocomplete] = useState(null); //store search autocomplete value
    
    //functions for google maps autocomplete components (from google maps Docmintations)
    const onLoad = (autoC) => setAutocomplete(autoC);

    const onPlaceChanged = () => {
        const lat = autocomplete.getPlace().geometry.location.lat();
        const lng = autocomplete.getPlace().geometry.location.lng();    
        setCoordinates({ lat, lng });
      };   
     

    return (      //showing the header using AppBar & Toolbar components then the search Autocomplete component
        <AppBar position="static">
         <Toolbar className={classes.toolbar}>
             <Typography variant="h4" className={classes.title}>
                  Travel Advisor
             </Typography>
             <Box display='flex'>
              <Typography variant="h6" className={classes.title}>
                  Explore new places ...
              </Typography>
             <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}> 
                <div className={classes.search}>
                   <div className={classes.searchIcon}>
                       <SearchIcon />
                    </div>
                    <InputBase placeholder="Search…" classes={{ root: classes.inputRoot,  input: classes.inputInput, }}  />
               </div>
            </Autocomplete>  
             </Box>
        </Toolbar>
        </AppBar>   
    )
}

export default Header
